import {
  Component,
  ComponentRef,
  inject,
  Injector,
  OnDestroy,
  OnInit,
  viewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { QuarterSelectorOverlayComponent } from './quarter-selector-overlay/quarter-selector-overlay.component';
import { QuarterSelectorStateService } from './quarter-selector-overlay/quarter-selector.state';
import { RangeQuarterSelectorService } from './range-quarter-selector.service';
const ESCAPE = 27;
const TAB = 9;
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'range-quarter-selector.component.html',
  styleUrl: 'range-quarter-selector.component.scss',
  host: {
    'data-rqs-component-scope': 'app-shared',
    '(document:keydown)': 'handleKeydown($event)',
  },
})
export class RangeQuarterSelectorComponent implements OnInit, OnDestroy {
  private readonly container = viewChild('selectorContainer', { read: ViewContainerRef });
  private minSelector: ComponentRef<QuarterSelectorOverlayComponent> = null;
  private maxSelector: ComponentRef<QuarterSelectorOverlayComponent> = null;
  private readonly parentInjector = inject(Injector);
  private readonly stateService = inject(RangeQuarterSelectorService);
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Tab') {
      this.stateService.close();
    }
  }
  ngOnInit() {
    const minService = this.stateService.getMinService();
    const minInjector: Injector = Injector.create({
      providers: [{ provide: QuarterSelectorStateService, useValue: minService, deps: [] }],
      parent: this.parentInjector,
    });
    this.minSelector = this.container().createComponent(QuarterSelectorOverlayComponent, { injector: minInjector });
    if (!this.stateService.isSingleSelection) {
      const maxService = this.stateService.getMaxService();
      minService.label = 'From';
      maxService.label = 'To';
      const maxInjector: Injector = Injector.create({
        providers: [{ provide: QuarterSelectorStateService, useValue: maxService, deps: [] }],
        parent: this.parentInjector,
      });
      this.maxSelector = this.container().createComponent(QuarterSelectorOverlayComponent, { injector: maxInjector });
    }
  }
  ngOnDestroy() {
    if (this.minSelector) {
      this.minSelector.destroy();
      this.minSelector = null;
    }
    if (this.maxSelector) {
      this.maxSelector.destroy();
      this.maxSelector = null;
    }
    this.container().clear();
  }
}
